<script>
export default {
  methods: {
    getPriceDiff(item) {
      const { list_price = 0, sale_price = 0 } = item
      if(!list_price) return 0

      return Math.ceil((list_price - sale_price) * 100 / list_price)
    }
  },
  computed: {
    packages() {
      return this.siteData?.packages ?? []
    }
  }
}
</script>

<template>
  <section id="pricing" class="py-8">
    <v-container :fluid="isMiniPc">
      <h1 class="text-center font-weight-light display-2 mb-10">Üyelik Paketleri</h1>
      <v-row no-gutters class="packages-row">
        <v-col v-for="(plan, index) in packages" :key="`plan-${index}`" :cols="$vuetify.breakpoint.xsOnly ? 12 : null">
          <v-card outlined>
            <v-toolbar color="primary" dark>
              <v-card-title bg-color="primary">{{ plan?.visible_name || '-' }}</v-card-title>
            </v-toolbar>
            <v-card-text>
              <div class="pricing-section" v-if="plan.sale_price">
                <div class="d-flex align-start mb-2">
                  <span style="font-size: 25px" class="text--primary font-weight-bold mr-1">
                    {{ formatPrice(plan?.sale_price ?? 0) }}
                  </span>
                  <span class="app-orange--text font-weight-bold" style="font-size: 14px; line-height: 14px;">+ KDV</span>
                </div>
                <div class="d-flex align-baseline">
                  <span style="font-size: 16px; text-decoration:line-through;" class="grey--text font-weight-bold mr-1">
                    {{ formatPrice(plan?.list_price ?? 0) }}
                  </span>
                  <span class="grey--text font-weight-bold" style="font-size: 10px; line-height: 10px; text-decoration:line-through;">+ KDV</span>
                </div>
                <div class="diff" v-if="getPriceDiff(plan) > 0">
                  <span style="font-size: 25px">% {{ getPriceDiff(plan) }}</span>
                  İndirim
                </div>
              </div>
              <div v-else>
                <div class="d-flex justify-center align-center py-4" style="height: 52px;">
                  <span style="font-size: 35px" class="app-orange--text font-weight-bold">
                    ÜCRETSİZ
                  </span>
                </div>
              </div>
              <div v-html="plan.description"></div>
            </v-card-text>
            <v-card-actions>
              <v-hover
                v-slot="{ hover }"
              >
                <v-expand-transition>
                  <v-btn
                    block
                    :color="hover ? 'primary' : 'app-orange'"
                    :elevation="hover ? 6 : 0"
                    dark
                    :href="`${appUrl}/#/buy/${plan.code}`"
                  >
                    Hemen Satın Al
                  </v-btn>
                </v-expand-transition>
              </v-hover>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<style scoped lang="scss">
$app-orange: #fb6625;

.pricing-section {
  position: relative;
  .diff {
    position: absolute;
    top: 50%;
    right: -16px;
    background-color: $app-orange;
    color: #FFF;
    padding: 5px 10px;
    width: 80px;
    border-radius: 6px 0 0 6px;
    transform: translate(0, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}
@media screen and (max-width: 600px) {
	.packages-row {
		gap: 15px;
	}
}
</style>